import Local from '@/app/module/local'
import Response from '@/app/model/api/response/responseValue'

class LoginApi {
  public doLogin (bodyData: {[key:string]: string}) {
    const path:string = '/v1/auth/user/signin'

    return fetch(process.env.VUE_APP_API_URL + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyData)
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        if (data.status_code === '200') {
          Local.setAuthToken(data.payload.authToken)
          Local.setUserId(data.payload.user_id)
          Local.setUserName(data.payload.user_name)
          Local.setUserType(data.payload.user_type)
          Local.setCompanyId(data.payload.company_id)
          return new Response(true, {})
        } else {
          throw data
        }
      })
      .catch(e => {
        if (Object.keys(e).indexOf('status_code') !== -1) {
          // ボディが存在する場合
          return new Response(false, e)
        } else {
          // ボディが存在しない場合(server errorになる)
          return new Response(false, {
            'message': 'server error'
          })
        }
      })
  }
}

export default new LoginApi()
